import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Array de cuatro valores aleatorios
const randomArray = Array.from({ length: 4 }, () => Math.floor(Math.random() * 100));
console.log('Array de valores aleatorios:', randomArray);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

